import { Button, Checkbox, Input, Typography } from 'antd';
import { useState } from 'react';

import type { FC } from 'react';

const PF = 'client-data';
const FIELD_NAME_MAX_LENGTH = 255;
const FIELD_VALUE_MAX_LENGTH = 5000;
const { Text } = Typography;
const { TextArea } = Input;

export interface InlineFieldCreatorValues {
  name: string;
  isImportant: boolean;
  value: string;
}

interface InlineFieldCreatorProps {
  isSubmitting: boolean;
  onSubmit: (values: InlineFieldCreatorValues) => Promise<void> | void;
  onCancel: () => void;
}

/**
 * Инлайн-создание дополнительного поля прямо в форме клиента: название на
 * месте лейбла, чекбокс важности, сразу вводится значение. Контролируемые
 * инпуты без antd Form — вложенная форма внутри <Form> страницы невозможна
 * (nested form в DOM).
 */
export const InlineFieldCreator: FC<InlineFieldCreatorProps> = ({
  isSubmitting,
  onSubmit,
  onCancel,
}) => {
  const [name, setName] = useState('');
  const [isImportant, setIsImportant] = useState(false);
  const [value, setValue] = useState('');

  const isNameEmpty = !name.trim();

  return (
    <div className={`${PF}_fields_inline-create`}>
      <div className={`${PF}_fields_item ${PF}_fields_item--textarea`}>
        <span className={`${PF}_fields_inline-create_name`}>
          <Input
            size="large"
            placeholder="Название поля"
            maxLength={FIELD_NAME_MAX_LENGTH}
            value={name}
            onChange={(event) => setName(event.target.value)}
            disabled={isSubmitting}
            data-testid="client-inline-field-name"
          />
          <Checkbox
            checked={isImportant}
            onChange={(event) => setIsImportant(event.target.checked)}
            disabled={isSubmitting}
            data-testid="client-inline-field-important"
          >
            <Text type="secondary">Важное</Text>
          </Checkbox>
        </span>
        <TextArea
          rows={2}
          placeholder="Значение"
          maxLength={FIELD_VALUE_MAX_LENGTH}
          value={value}
          onChange={(event) => setValue(event.target.value)}
          disabled={isSubmitting}
          data-testid="client-inline-field-value"
        />
      </div>
      <div className={`${PF}_fields_inline-create_actions`}>
        <Button
          type="primary"
          onClick={() => onSubmit({ name, isImportant, value })}
          disabled={isNameEmpty || isSubmitting}
          loading={isSubmitting}
          data-testid="client-inline-field-save"
        >
          Сохранить поле
        </Button>
        <Button
          onClick={onCancel}
          disabled={isSubmitting}
          data-testid="client-inline-field-cancel"
        >
          Отмена
        </Button>
      </div>
    </div>
  );
};
